import { View } from "react-native";
import CollectDataField from "src/api/graphql/__generated__/enums/CollectDataField";
import GatheringRelationshipEnum from "src/api/graphql/__generated__/enums/GatheringRelationshipEnum";
import InstagramBadge from "src/components/InstagramBadge";
import LinkedInBadge from "src/components/LinkedInBadge/LinkedInBadge";
import Profile from "src/components/Profile";
import ProfilePicture from "src/components/ProfilePicture";
import SnapchatBadge from "src/components/SnapchatBadge";
import { useClientId } from "src/helpers/globalHelpers";
import type {
	UseGatheringAndUsers_Gathering,
	UseGatheringAndUsers_User,
} from "src/hooks/useGatheringAndUsers";
import IconCrown from "src/icons/IconCrown";
import IconFlash from "src/icons/IconFlash";
import IconVerified from "src/icons/IconVerified";
import { paddingMedium, paddingSmall } from "src/styles/spacing";
import { Text } from "src/swsh-native";
import { GatheringViewerHorizontalPadding, GatheringViewerRowHeight } from "../../constants";
import GatheringViewerFilterToggle from "./components/GatheringViewerFilterToggle";
import GatheringViewerOptions from "./components/GatheringViewerOptions";

const UserBadgeSize = 16;
const GatheringViewerRow = ({
	user,
	access,
	gatheringId,
	onAction,
	displayContent,
}: {
	user: UseGatheringAndUsers_User;
	access: UseGatheringAndUsers_Gathering["access"];
	gatheringId: string;
	displayContent: (CollectDataField | "Snapchat")[];
	onAction?: () => void;
}) => {
	const clientId = useClientId();

	return (
		<View
			style={{
				height: GatheringViewerRowHeight,
				width: "100%",
				alignItems: "center",
				flexDirection: "row",
				paddingHorizontal: GatheringViewerHorizontalPadding,
				justifyContent: "space-between",
				overflow: "hidden",
			}}
		>
			<View
				testID="GatheringViewerRow"
				style={{
					flexDirection: "row",
					alignItems: "center",
					columnGap: paddingMedium,
				}}
			>
				<Profile userId={user.userId}>
					<ProfilePicture userId={user.userId} size={48} />
				</Profile>
				<View
					style={{
						flexDirection: "column",
						rowGap: paddingMedium,
					}}
				>
					<View
						style={{
							flexDirection: "row",
							columnGap: paddingSmall,
							alignItems: "center",
						}}
					>
						{user.gatheringRelationship === GatheringRelationshipEnum.Admin ? (
							<IconCrown size={UserBadgeSize} />
						) : (user.numPhotosUploaded ?? 0) > 0 ? (
							<IconFlash size={UserBadgeSize} />
						) : null}
						{user.isVerified && <IconVerified size={UserBadgeSize} />}
						<Profile userId={user.userId}>
							<Text semibold>
								{clientId === user.userId
									? "You"
									: `${user.firstName ?? ""} ${user.lastName ?? ""}`}
							</Text>
						</Profile>
					</View>
					<View
						style={{
							flexDirection: "row",
							columnGap: paddingSmall,
						}}
					>
						{displayContent.includes(CollectDataField.Instagram) && (
							<InstagramBadge instagramUsername={user.instagramUsername} />
						)}
						{displayContent.includes(CollectDataField.LinkedIn) && (
							<LinkedInBadge linkedInUsername={user.linkedInUsername} />
						)}
						{displayContent.includes("Snapchat") && (
							<SnapchatBadge snapchatUsername={user.snapchatUsername} />
						)}
					</View>
				</View>
			</View>
			<View
				style={{
					flexDirection: "row",
					alignItems: "center",
					columnGap: paddingMedium,
				}}
			>
				<GatheringViewerFilterToggle user={user} />
				<GatheringViewerOptions
					user={user}
					access={access}
					gatheringId={gatheringId}
					onAction={onAction}
				/>
			</View>
		</View>
	);
};
export default GatheringViewerRow;
